<template>
<div class="index">
  <van-button type="primary" style="margin-bottom: 20px;border-radius: 5px;height: 60px;font-size: 20px" block @click="openXueyuan(0)">学员登录</van-button>
  <van-button type="info"  block style="border-radius: 5px;height: 60px;font-size: 20px" @click="openXueyuan(1)">驾校登录</van-button>
</div>
</template>

<script>
export default {
  name: "index",
  methods:{
    openXueyuan(type){
      if (type == 0){

        this.$router.push('/orderQuery');
      }else {
        this.$router.push('/dirverLogin');
      }

    }
  }
}
</script>

<style scoped>
.index{
margin-top: 40%;
  margin-left: 20%;
  width: 60%;
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// index.vue?2b7793c2